module.exports = __webpack_public_path__ + "static/car1-4a26c49a7af7bae00dcb1fb1e774454c.jpg";